import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Dashboard from "../pages/dashboard/page";
import Prospectar from "../pages/prospectar/page";
import Contactos from "../pages/contactos/page";
import MiRuta from "../pages/mi-ruta/page";
import Cursos from "../pages/cursos/page";
import CursoDetalle from "../pages/curso-detalle/page";
import Resultado from "../pages/resultado/page";
import Test from "../pages/test/page";
import GuiaIA from "../pages/guia-ia/page";
import Reuniones from "../pages/reuniones/page";
import Perfil from "../pages/perfil/page";
import Apariencia from "../pages/apariencia/page";
import AdminResumen from "../pages/admin/page";
import AdminUsuarios from "../pages/admin/usuarios/page";
import AdminCumplimiento from "../pages/admin/cumplimiento/page";
import AdminComunidad from "../pages/admin/comunidad/page";
import Comunidad from "../pages/comunidad/page";
import Retos from "../pages/retos/page";
import AdminAfiliados from "../pages/admin/afiliados/page";
import AdminEventos from "../pages/admin/eventos/page";
import MisProspectos from "../pages/mis-prospectos/page";
import MiLink from "../pages/mi-link/page";
import Lider from "../pages/lider/page";
import Notificaciones from "../pages/notificaciones/page";
import ReunionesPanel from "../pages/reuniones-panel/page";
import AdminNotificaciones from "../pages/admin/notificaciones/page";
import Afiliado from "../pages/afiliado/page";
import Registro from "../pages/registro/page";
import Webinar from "../pages/webinar/page";
import AdminWebinar from "../pages/admin/webinar/page";
import AdminWhatsApp from "../pages/admin/whatsapp/page";
import MiWhatsApp from "../pages/mi-whatsapp/page";
import WebinarAfiliado from "../pages/webinar-afiliado/page";
import RequireAuth from "../components/feature/RequireAuth";
import RequireAdmin from "../components/feature/RequireAdmin";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/registro/:code", element: <Registro /> },
  { path: "/webinar", element: <Webinar /> },
  { path: "/app/dashboard", element: <RequireAuth><Dashboard /></RequireAuth> },
  { path: "/app/prospectar", element: <RequireAuth><Prospectar /></RequireAuth> },
  { path: "/app/contactos", element: <RequireAuth><Contactos /></RequireAuth> },
  { path: "/app/mi-ruta", element: <RequireAuth><MiRuta /></RequireAuth> },
  { path: "/app/cursos", element: <RequireAuth><Cursos /></RequireAuth> },
  { path: "/app/cursos/:courseId", element: <RequireAuth><CursoDetalle /></RequireAuth> },
  { path: "/app/resultado", element: <RequireAuth><Resultado /></RequireAuth> },
  { path: "/app/test", element: <RequireAuth><Test /></RequireAuth> },
  { path: "/app/guia-ia", element: <RequireAuth><GuiaIA /></RequireAuth> },
  { path: "/app/reuniones", element: <RequireAuth><Reuniones /></RequireAuth> },
  { path: "/app/comunidad", element: <RequireAuth><Comunidad /></RequireAuth> },
  { path: "/app/retos", element: <RequireAuth><Retos /></RequireAuth> },
  { path: "/app/mis-prospectos", element: <RequireAuth><MisProspectos /></RequireAuth> },
  { path: "/app/mi-whatsapp", element: <RequireAuth><MiWhatsApp /></RequireAuth> },
  { path: "/app/mi-link", element: <RequireAuth><MiLink /></RequireAuth> },
  { path: "/app/lider", element: <RequireAuth><Lider /></RequireAuth> },
  { path: "/app/notificaciones", element: <RequireAuth><Notificaciones /></RequireAuth> },
  { path: "/app/reuniones/panel", element: <RequireAuth><ReunionesPanel /></RequireAuth> },
  { path: "/app/afiliado", element: <RequireAuth><Afiliado /></RequireAuth> },
  { path: "/app/perfil", element: <RequireAuth><Perfil /></RequireAuth> },
  { path: "/app/apariencia", element: <RequireAuth><Apariencia /></RequireAuth> },
  { path: "/app/admin", element: <RequireAuth><RequireAdmin><AdminResumen /></RequireAdmin></RequireAuth> },
  { path: "/app/admin/usuarios", element: <RequireAuth><RequireAdmin><AdminUsuarios /></RequireAdmin></RequireAuth> },
  { path: "/app/admin/cumplimiento", element: <RequireAuth><RequireAdmin><AdminCumplimiento /></RequireAdmin></RequireAuth> },
  { path: "/app/admin/comunidad", element: <RequireAuth><RequireAdmin><AdminComunidad /></RequireAdmin></RequireAuth> },
  { path: "/app/admin/afiliados", element: <RequireAuth><RequireAdmin><AdminAfiliados /></RequireAdmin></RequireAuth> },
  { path: "/app/admin/eventos", element: <RequireAuth><RequireAdmin><AdminEventos /></RequireAdmin></RequireAuth> },
  { path: "/app/admin/notificaciones", element: <RequireAuth><RequireAdmin><AdminNotificaciones /></RequireAdmin></RequireAuth> },
  { path: "/app/webinar", element: <RequireAuth><WebinarAfiliado /></RequireAuth> },
  { path: "/app/admin/webinar", element: <RequireAuth><RequireAdmin><AdminWebinar /></RequireAdmin></RequireAuth> },
  { path: "/app/admin/whatsapp", element: <RequireAuth><RequireAdmin><AdminWhatsApp /></RequireAdmin></RequireAuth> },
  { path: "*", element: <NotFound /> },
];

export default routes;
